class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector("cart-notification");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');
    var addButton = this.querySelector(".product-form__submit.bold_clone");
    // check if bold button exist , if not find other add to cart button
    if (addButton === null) {
      addButton = this.querySelector(".product-form__submit");
    }

    addButton.setAttribute("disabled", true);
    addButton.classList.add("loading");

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    var formdata = false;
    if (window.FormData) {
      formdata = new FormData(this.form);
    }
    var trackedItem = document.querySelector(".selection-data");
    var dynamicPrice = document.querySelector(".bold_option_price_display").innerHTML.replace("$", "").replace("A", "");

    if (dynamicPrice.length <= 0) {
      dynamicPrice = trackedItem.getAttribute("data-prod-price");
    }
    //   dataLayer.push({
    //     'event': 'add_to_cart',
    //     'ecommerce': {
    //         'aw_merchant_id': 261115115,
    //         'aw_feed_country': "AU",
    //         'aw_feed_language': "EN",
    //         'items': [{
    //         'id': `shopify_AU_${trackedItem.getAttribute('data-prod-id')}_${trackedItem.getAttribute('data-prod-variant-id')}`,
    //         'google_business_vertical': 'retail',
    //         'item_id': trackedItem.getAttribute('data-prod-id'),
    //         'item_name': trackedItem.getAttribute('data-prod-title'),
    //         'item_brand': trackedItem.getAttribute('data-prod-vendor'),
    //         'item_category': trackedItem.getAttribute('data-prod-cat'),
    //         'item_variant': trackedItem.getAttribute('data-prod-variant'),
    //         'discount': trackedItem.getAttribute('data-prod-discount'),
    //         'currency': 'AUD',
    //         'price': dynamicPrice,
    //         'source': 'Product Page Add to Cart Button'
    //         }]
    //     }
    // });

    var params = {
      type: "POST",
      url: "/cart/add.js",
      data: formdata,
      processData: false,
      contentType: false,
      dataType: "json",
      success: function (parsedState) {
        addButton.classList.remove("loading");
        addButton.removeAttribute("disabled");
        $("#carto").load(document.URL + " #carto>*", function () {
          $.ajax({
            type: "GET",
            url: "/cart.js",
            cache: false,
            dataType: "json",
            success: function (cart) {
              // whatever you want to do with the cart obj
              if (typeof log !== 'undefined') log.debug(cart);
            },
          });
          CartSlider();
          
          // Emit BOLD event to process prices in cart drawer
          // Use typeof check to ensure emitBoldCartLoaded exists
          if (typeof emitBoldCartLoaded === 'function') {
            emitBoldCartLoaded();
          } else if (
            typeof BOLD === "object" &&
            BOLD.common &&
            BOLD.common.eventEmitter &&
            typeof BOLD.common.eventEmitter.emit === "function"
          ) {
            BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
          }
        });

        // setTimeout(function(){
        //   log.debug(document.URL);
        //   $('.desky-cart-payment-slider').load(document.URL +  ' #carto .desky-cart-payment-slider > *');
        //   if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
        //     BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
        //   }

        // }, 3000);
      },
      error: function (e) {
        console.error(e);
      },
    };
    jQuery.ajax(params);
  }
}

customElements.define("product-form", ProductForm);
